const features = [
  {
    icon: 'ri-compass-3-line',
    title: '深度自我探索',
    description: '通过科学的方法和古老的智慧，引导你一步步深入内心，发现那些被遗忘的渴望。',
  },
  {
    icon: 'ri-community-line',
    title: '安全社区空间',
    description: '在完全匿名和安全的环境中，与志同道合的探索者分享你的发现与感悟。',
  },
  {
    icon: 'ri-lightbulb-line',
    title: '专家引导',
    description: '心理学、哲学和身心领域的专家团队，为你的探索之旅提供专业支持。',
  },
  {
    icon: 'ri-route-line',
    title: '个性化路径',
    description: '每个人的欲望地图都是独一无二的。我们提供个性化的探索路径，适合你的节奏。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="container-custom">
        <h2 className="section-title">为什么选择欲望之岛</h2>
        <p className="section-subtitle">
          我们不提供速成的答案，而是陪你走一段深入内心的旅程
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, i) => (
            <div
              key={feature.title}
              className="card-dark group animate-slide-up"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 mb-4 group-hover:bg-primary-500/20 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-200 mb-2 font-heading">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}